export default __webpack_public_path__ + "static/media/20.0aa7c498.png";